/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_BodyInputs */

const en_features_gym_body = /** @type {(inputs: Features_Gym_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your gym on the map or train at home, and the plan chooses exercises for the equipment that is really there.`)
};

const pl_features_gym_body = /** @type {(inputs: Features_Gym_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz siłownię z mapy albo trenuj w domu, a plan dobierze ćwiczenia do sprzętu, który naprawdę tam stoi.`)
};

/**
* | output |
* | --- |
* | "Pick your gym on the map or train at home, and the plan chooses exercises for the equipment that is really there." |
*
* @param {Features_Gym_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_body = /** @type {((inputs?: Features_Gym_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_body(inputs)
	return en_features_gym_body(inputs)
});